import { resolveTourStepsForRole } from "../resolveTourStepsForRole";

function copy(title, content) {
  return {
    Admin: { title, content },
    Manager: { title, content },
    "Sales Rep": { title, content },
  };
}

const STEP_DEFS = [
  {
    selector: '[data-tour="lead-detail-contact-info"]',
    placement: "bottom",
    copy: copy(
      "Contact information",
      "Name, phone, email, address, status, assigned rep, and coordinates for this lead. Use View on Map in the header when the lead is geocoded."
    ),
  },
  {
    selector: '[data-tour="lead-detail-contact-edit"]',
    placement: "left",
    copy: copy(
      "Edit contact",
      "Tap the pencil to update contact fields inline. Save applies changes across the CRM; Cancel discards edits. Follow-up date is required when status is Follow Up Needed."
    ),
  },
  {
    selector: '[data-tour="lead-detail-view-on-map"]',
    placement: "bottom",
    copy: copy(
      "View on map",
      "Opens the leads map centered on this address when latitude and longitude are available. Use it to see the pin in context with nearby leads."
    ),
  },
  {
    selector: '[data-tour="lead-detail-property-details"]',
    placement: "top",
    copy: copy(
      "Property details",
      "Property type, sold date, price, square footage, year built, and leadership-only additional notes for proposals and qualification."
    ),
  },
  {
    selector: '[data-tour="lead-detail-notes-followups"]',
    placement: "top",
    copy: copy(
      "Notes & follow-ups",
      "Edit notes for this lead, see scheduled follow-ups with due dates and status, and track what still needs a callback."
    ),
  },
  {
    selector: '[data-tour="lead-detail-activity-timeline"]',
    placement: "top",
    copy: copy(
      "Activity timeline",
      "A chronological feed of everything that happened on this lead—status changes, notes, follow-ups, messages, and system events—newest activity first so you can see the full story at a glance."
    ),
  },
];

export const LEAD_DETAIL_TOUR_STEPS = (role, options) =>
  resolveTourStepsForRole(STEP_DEFS, role, options);

export const LEAD_DETAIL_NEW_STEPS = () => [];
